import React from 'react';

import { Callback } from '../auths/Callback';

export const RoutesAnonymous = () => {
  return <Callback />
}